import { all, fork } from 'redux-saga/effects';
import { achSaga } from './Ach';
import { alertsSaga } from './Alerts';
import { daySegmentsSaga } from './DaySegments';
import { employeePayrollTipsSaga } from './EmployeePayrollTips';
import { employeesSaga } from './Employees';
import { integrationsSaga } from './Integrations';
import { jobTitlesSaga } from './Jobs';
import { ledgersSaga } from './Ledger';
import { paymentsSagas } from './Payments';
import { payoutsSagas } from './Payouts';
import { payPeriodsSaga } from './PayPeriods';

function* collectionsSaga() {
  yield all([
    fork(achSaga),
    fork(alertsSaga),
    fork(daySegmentsSaga),
    fork(employeePayrollTipsSaga),
    fork(jobTitlesSaga),
    fork(ledgersSaga),
    fork(paymentsSagas),
    fork(payoutsSagas),
    fork(payPeriodsSaga),
    fork(employeesSaga),
    fork(integrationsSaga),
  ]);
}

export { collectionsSaga };
